// extracted by mini-css-extract-plugin
export default {"linkButton":"SearchLinkCell_linkButton__OiJbf"};